import { Navigate } from 'react-router-dom';
import Login from '../pages/auth/Login';
import Forgot from '../pages/auth/Forgot';
import EmailSend from '../pages/auth/EmailSend';
import ResetPassword from '../pages/auth/ResetPassword';
import ResetPasswordSuccess from '../pages/auth/ResetPasswordSuccess';
import { jwtDecode } from 'jwt-decode';
import i18n from 'i18next';

const t = i18n.t.bind(i18n);

// Obtener roles basados en el JWT almacenado
let hasAdminRole = false;
let hasTechnicalRole = false;
let hasBreederRole = false;

const jwt = localStorage.getItem("jwt");
if (jwt && jwt !== "undefined") {
    try {
        const decoded = jwtDecode(jwt);
        if (decoded) {
            hasAdminRole = decoded.rol === "admin";
            hasTechnicalRole = decoded.rol === "technical";
            hasBreederRole = decoded.rol === "breeder";
        }
    } catch (error) {
        console.error("Error decoding JWT", error);
    }
}

// Mapeo de alias a paths reales
export const aliasMapAuth = {
    "": "home",
    "/": "home",
    "logout": "logout",
    [t("url.auth.login")]: "login",
    [t("url.auth.lobby")]: "lobby",
    [t("url.auth.forgotpassword")]: "forgotpassword",
    [`${t("url.auth.emailsend")}/:email`]: "emailsend/:email",
    [`${t("url.auth.resetpassword")}/:id/:tokenresetpassword`]: "resetpassword/:id/:tokenresetpassword",
    [t("url.auth.resetpasswordsuccess")]: "resetpasswordsuccess",
};

// Función para obtener el componente basado en el path real
export const getComponentAuth = (path) => {
    switch (path) {
        case "":
        case "home":
        case "login":
            if (hasAdminRole) return <Navigate to={`${t("url.admin.admin")}/${t("url.admin.dashboard")}`} replace />;
            if (hasTechnicalRole) return <Navigate to={`${t("url.technical.technical")}/${t("url.technical.dashboard")}`} replace />;
            if (hasBreederRole) return <Navigate to={`${t("url.breeder.breeder")}/${t("url.breeder.dashboard")}`} replace />;
            return <Login />;
        case "forgotpassword":
            return <Forgot />;
        case "emailsend/:email":
            return <EmailSend />;
        case "resetpassword/:id/:tokenresetpassword":
            return <ResetPassword />;
        case "resetpasswordsuccess":
            return <ResetPasswordSuccess />;
        case "logout":
            return <Login />;
        default:
            return <Login />;
    }
};
